import React from 'react';

import { Select } from '@aline/common';
import { link } from '@aline/routes';
import { Typography } from '@mui/material';
import type { GridCellParams } from '@mui/x-data-grid-premium';
import { Link } from 'react-router-dom';
import type { ReportsListRow } from 'src/components';
import { ReportIcon } from 'src/components/icons/ReportIcon';
import { useSelectCurrentUser } from 'src/gql';
import { createClampStyles } from 'src/theme';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  cell: {
    overflow: 'hidden',
    width: '100%',
  },
  icon: {
    alignItems: 'center',
    display: 'flex',
  },
  nameLink: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(2),
    textDecoration: 'none',
    width: '100%',
  },
  nameText: {
    color: theme.appColors.iconsType,
    ...createClampStyles(2),
  },
}));

export function ReportsListNameCell({
  row,
  value,
}: GridCellParams<ReportsListRow, string>): JSX.Element {
  const { classes } = useStyles();
  const currentUser = useSelectCurrentUser();
  const isExampleReport = currentUser?.settings.exampleReport?.id === row.id;

  return (
    <div
      className={classes.cell}
      data-cy={isExampleReport ? Select.report.exampleReport : undefined}
    >
      <Link
        className={classes.nameLink}
        to={link.ReportDetail({ reportId: row.id })}
        onClick={e => e.stopPropagation()}
      >
        <div className={classes.icon}>
          <ReportIcon />
        </div>
        <Typography className={classes.nameText} variant="body1">
          {value}
        </Typography>
      </Link>
    </div>
  );
}
